import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Appraisal, Approvalform, ApprovalList, EmployeeAssesment, Hike, HikeDto, MetricDto, PerformanceDto, PromotionDto } from 'src/app/shared/models/appraisal';
import { Context } from 'src/app/shared/models/context';
import { Evaluation, Message, PrivilegeType } from 'src/app/shared/models/domain';
import { ApparaisalService } from 'src/app/shared/services/apparaisal.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';
@Component({
  selector: 'app-manage-evaluation',
  templateUrl: './manage-evaluation.component.html',
  styleUrls: ['./manage-evaluation.component.scss']
})
export class ManageEvaluationComponent implements OnInit {
  @Input() approvals?: ApprovalList[] = [];
  @Input() approval: ApprovalList;
  @Input() context: Context;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  public searchKeyword: string = "";
  public privilege: PrivilegeType;
  public isLoading: boolean = true;
  public appraisals: Appraisal[] = [];
  public employeeAssesment: EmployeeAssesment;
  public evaluationForm: FormGroup;
  public evaluation: Evaluation;
  public appraisalId: number;
  public appraiseeId: number;
  public evaluationId: number;
  public evaluationStatus: boolean;
  public appraisal: Appraisal;
  public hikes: Hike[];
  public hikeValue: number;
  constructor(
    private dataService: DataService,
    private commonService: CommonService,
    public activeModal: NgbActiveModal,
    private appraisalService: ApparaisalService,
    private fb: FormBuilder,
    private toaster: ToastrService,
  ) { }

  ngOnInit(): void {
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.setEvaluationForm(undefined);
    this.getEmployeeAssessment();
    this.getAppraisal(this.approval.appraisalId);
    if (this.hikes?.length > 0) {
      this.hikeValue = this.hikes[0].value || 0;
    }
  }

  public getEmployeeAssessment() {
    if (this.approval.appraisalId && this.approval.appraiseeId) {
      this.appraisalService.getAssessment(this.approval.appraisalId, this.approval.appraiseeId).subscribe({
        next: (employeeAssesment: EmployeeAssesment) => {
          this.employeeAssesment = employeeAssesment;
          this.getEvaluation(employeeAssesment.id);
          this.getHike(employeeAssesment.id)
          this.appraisalId = this.approval.appraisalId;
          this.appraiseeId = this.approval.appraiseeId;
          this.evaluationStatus = (this.approval.status === 'HR_COMPLETED');
        }
      });
    }
  }

  public getEvaluation(id: number) {
    this.appraisalService.getEvaluations(id).subscribe({
      next: (evaluation: Evaluation) => {
        this.setEvaluationForm(evaluation);
        this.evaluation = evaluation;
        this.evaluationId = this.evaluation.id;
        this.evaluationForm.patchValue({ status: evaluation.status });
      }
    })

  }

  public upsertAssessmentStatus(message: Message) {
    this.employeeAssesment.status = "HR_COMPLETED"

    this.appraisalService.updateApprovalForm(this.employeeAssesment.id, this.employeeAssesment).subscribe({
      next: (updatedApproval: any) => {
        this.passEntry.emit(message);
      },
    });
  }


  public setEvaluationForm(evaluation: Evaluation) {
    if (!evaluation) {
      evaluation = {
        id: null,
        comments: null,
        status: '',
        addresseeId: this.context?.employeeId,
        addresseeName: null,
        assessmentId: this.employeeAssesment?.id,
        assessmentName: null,
      } as Evaluation;
      this.evaluationForm = this.fb.group({
        id: this.fb.control(evaluation.id),
        comments: this.fb.control(evaluation.comments, [Validators.required]),
        status: this.fb.control(evaluation.status, [Validators.required]),
        addresseeId: this.fb.control(evaluation.addresseeId, []),
        addresseeName: this.fb.control(evaluation.addresseeName),
        assessmentId: this.fb.control(evaluation.assessmentId, []),
        assessmentName: this.fb.control(evaluation.assessmentName)
      });
    }
  }

  public saveEvaluation(inProgress?: any) {
    this.evaluationForm.patchValue({
      addresseeId: this.context?.employeeId,
      assessmentId: this.employeeAssesment?.id
    } as Evaluation);
    if (this.evaluationForm.valid) {
      let evaluation = this.evaluationForm.value as Evaluation;
      if (this.context?.employeeId &&this.employeeAssesment?.id) {
        inProgress.value = true;
        if (this.evaluationId) {
          this.appraisalService.updateEvaluation(this.evaluationId, evaluation).subscribe({
            next: (message: Message) => {
              if (!message.failed) {
                this.upsertAssessmentStatus(message);

                this.activeModal.close();
                this.evaluationForm.get("id").setValue(parseInt(message.payload));
                this.toaster.success(message.text);
              } else {
                inProgress.value = false;
                this.toaster.error(message.text);
              }
            },
            error: (error: HttpErrorResponse) => {
              inProgress.value = false;
              this.toaster.error(error?.error?.name || error.message);
            }
          });
        } else {
          this.appraisalService.createEvaluation(evaluation).subscribe({
            next: (message: Message) => {
              if (!message.failed) {
                inProgress.value = true;
                this.evaluationForm.get("id").setValue(parseInt(message.payload));
                this.upsertAssessmentStatus(message);
                this.activeModal.close();
                this.toaster.success(message.text);
              } else {
                inProgress.value = false;
                this.toaster.error(message.text);
              }
            },
            error: (error: HttpErrorResponse) => {
              inProgress.value = false;
              this.toaster.error(error?.error?.name || error.message);
            }
          });
        }
      } else {
        this.toaster.error('Appraisal ID or Appraisee ID is missing.');
      }
    } else {
      this.toaster.error('Please fill in the required fields.');
    }
  }

  private getAppraisal(id: number) {
    this.appraisalService.getAppraisal(id).subscribe(appraisal => this.appraisal = appraisal);
  }

  private getHike(id: number) {
    this.appraisalService.getHike(id).subscribe(hikes => {
      this.hikes = hikes;
      if (this.hikes && this.hikes.length > 0) {
        this.hikeValue = this.hikes[0].value || 0;
      }
    });
  }

}






